import React from "react";
import { Navigate } from "react-router-dom";

const ForgotRedirect = ({ children }) => {
  const userId = localStorage.getItem("userId");

  if (!userId) {
    return <Navigate to="/" replace />;
  }

  // ✅ If userId exists, allow access
  return <>{children}</>;
};

export default ForgotRedirect;
